import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { $host } from 'shared/api/base/http';
import { RootState } from 'shared/lib/store/redux';

import {
  IGetTeacherScheduleQueryArgs,
  IGetTeacherScheduleResponse,
  ISearchTeachersQueryArgs,
  ISearchTeachersResponse,
} from '../models/types';

export const searchTeachers = createAsyncThunk(
  'schedulePublic/searchTeachers',
  async ({ data }: ISearchTeachersQueryArgs, thunkApi) => {
    const state = thunkApi.getState() as RootState;
    const { token } = state.yaSmartCaptchaReducer;

    if (!token) {
      return thunkApi.rejectWithValue('Captcha verification required');
    }
    try {
      const res = await $host.get<ISearchTeachersResponse>(
        '/schedule_public/teachers',
        {
          params: {
            search: data,
          },
          headers: {
            'Content-Type': 'application/json',
            'X-Captcha-Token': token,
          },
        },
      );
      return res.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error as AxiosError);
    }
  },
);

export const getTeacherSchedule = createAsyncThunk(
  'schedulePublic/getTeacherSchedule',
  async (
    { teacherID, startDate, endDate }: IGetTeacherScheduleQueryArgs,
    thunkApi,
  ) => {
    const state = thunkApi.getState() as RootState;
    const { token } = state.yaSmartCaptchaReducer;

    if (!token) {
      return thunkApi.rejectWithValue('Captcha verification required');
    }
    try {
      const res = await $host.get<IGetTeacherScheduleResponse>(
        `/schedule_public/teachers/${teacherID}`,
        {
          headers: {
            'Content-Type': 'application/json',
            'X-Captcha-Token': token,
          },
        },
      );
      res.data.startDate = startDate;
      res.data.endDate = endDate;
      return res.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error as AxiosError);
    }
  },
);
